module.exports = __webpack_public_path__ + "img/Blog5.5.6c21c4b6.png";